const ROUTES = {
  "/": {
    "name": "HomePage8088edd1E4904e36B1b15ffd140601be",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPagesD0b5b1fcD7114af7Bab68ae47a893645",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPageBb943482580c43a8B2fdD7d45fbf6fc7",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPage9100b6d7832248949a12936c9b39d6f6",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/events/public": {
    "name": "PublicEventsPageD54dc73e1286411dBd7f17d177c4c87c",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage80386313C2f14ead9bd533009d247fec",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members/*": {
    "name": "MemberPages72450035244a4d629c9f626d6446fded",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages7dce09fbF4e64faa81c9A0f57e6de6f4",
    "type": "HTML",
    "key": "message-pages"
  },
  "/polytopia-2024": {
    "name": "Polytopia2024A4d3b27887e24828992d024ae228f018",
    "type": "HTML",
    "key": "polytopia-2024"
  },
  "/polytopia-2024/workshops": {
    "name": "Polytopia2024WorkshopsEdbfdf63E6234dc690dd62f8297be560",
    "type": "HTML",
    "key": "polytopia-2024-workshops"
  },
  "/polytopia-2025": {
    "name": "Polytopia20250d142b59382d480d8e3aC17e76089664",
    "type": "HTML",
    "key": "polytopia-2025"
  },
  "/polytopia-2025/handouts": {
    "name": "Polytopia2025Handouts9468e6b46d4d469c92b3504395d03abe",
    "type": "HTML",
    "key": "polytopia-2025-handouts"
  },
  "/polytopia-2025/presenters": {
    "name": "Polytopia2025Presenters35a51a19D8a9497c82457a271540eab9",
    "type": "HTML",
    "key": "polytopia-2025-presenters"
  },
  "/polytopia-2025/schedule": {
    "name": "Polytopia2025ScheduleFfcacf55341c4fe6B608Fc3e6475a485",
    "type": "HTML",
    "key": "polytopia-2025-schedule"
  },
  "/polytopia-2025/sponsors": {
    "name": "Polytopia2025Sponsors7ba7fb62Ffe0416289d81c7035ccbc45",
    "type": "HTML",
    "key": "polytopia-2025-sponsors"
  },
  "/polytopia-2025/workshops": {
    "name": "Polytopia2025Workshops9e0c4ad90bf54e728e1c041434ea9441",
    "type": "HTML",
    "key": "polytopia-2025-workshops"
  },
  "/polytopia-2026": {
    "name": "Polytopia2026D79d41ad6e8f4b089b145a8d1b5943e2",
    "type": "HTML",
    "key": "polytopia-2026"
  },
  "/polytopia-2026/handouts": {
    "name": "Polytopia2026Handouts85657ef65d9743acAa3a6750bf10a4d0",
    "type": "HTML",
    "key": "polytopia-2026-handouts"
  },
  "/resources": {
    "name": "ResourcesPage3d3a20f25587499c8e7684f0e506daca",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages4b19b3e488ce41999bb6Fa537dac159e",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;